module.exports = __webpack_public_path__ + "784b49344523db879fca99142f1ff745.svg";